<template>
    <main class="kvizove-ulohy">

        <article v-show="step === 'uvod'" class="d-grid position-relative uvod-height">
            <template v-if="skolskaUloha">
                <img v-if="skolskaUloha.pozadie" :src="skolyStorage + skolskaUloha.pozadie" alt="" class="uvodny-obr">
                <img v-else src="assets/img/uvod-kviz.jpg" alt="" class="uvodny-obr">
                <div class="position-absolute">
                    <span class="badge-pill --success mb-30">{{ skolskaUloha.nazov }}</span>
                    <h2 class="mb-30">{{ skolskaUloha.podnadpis }}</h2>
                    <p class="mb-50">{{ skolskaUloha.zadanie }}</p>
                    <button class="btn --primary btn-lg" @click="step='nahravanie'">Nahrať kresby<span class="icon --arrow-right"></span></button>
                </div>
            </template>
        </article>

        <article v-show="step === 'nahravanie'" class="screen-w-controls">
            <div class="top-info">
                <p><b v-if="skolskaUloha">{{ skolskaUloha.podnadpis }}</b></p>
                <span id="tooltip-target-1"><span class="icon --info-circle color-icon mr-10"></span>Kreatívnu úlohu vypracúva každý z triedy za seba, alebo celý kolektív spolu.<br> 100% bodov získava trieda v momente, keď každý za seba vypracoval úlohu podľa zadania a pani učiteľka/pán učiteľ nahrali všetky fotografie.</span>
                <b-tooltip target="tooltip-target-1" variant="danger" custom-class="dark-tooltip" triggers="hover">
                    
                </b-tooltip>
            </div>
            <vue-dropzone
                    id="submissionDropzone"
                    ref="submissionDropzone"
                    :options="dropzoneOptions"
                    :duplicateCheck="true"
                    :useCustomSlot="true"
                    @vdropzone-success="fileUploaded"
                    @vdropzone-sending="addAdditionalParams"
                    @vdropzone-error="fileUploadError"
                    @vdropzone-removed-file="fileRemoved"
            >
                <div class="dropzone-custom-content">
                    <img src="assets/img/upload-img.svg" alt="" class="img-fluid">
                    <h3 class="dropzone-custom-title">Preneste sem fotografie myškou,</h3>
                    <p class="mb-0">alebo kliknite na tlačítko + nižsie na nahrajte fotografie ručne.</p>
                </div>
            </vue-dropzone>

            <b-error :alert="error" />
            <div class="controls">
                <button class="btn --primary" @click="$refs.submissionDropzone.$el.click()"><span class="icon --plus"></span></button>
                <button :disabled="saving" class="btn --primary" @click="saveVypracovanie">Odoslať súbory<span class="icon --arrow-right ml-10"></span></button>
            </div>
        </article>

        <article v-show="step === 'vyhodnotenie'" class="d-grid position-relative bg-white full-h">
            <img src="assets/img/vyhodnotenie-bg.jpg" alt="" class="img-fluid">
            <div class="position-absolute">
                <img src="assets/img/success-badge.svg" alt="" class="img-fluid mb-20">
                <h2 class="mb-10">Výborne, zvládli ste to!</h2>
                <p class="mb-30">Kravička je na vás pyšná.</p>
                <p v-if="skolskaUloha && skolskaUloha.is_individualna" class="text-success text-48">
                    {{ vypracovanie.subory.length <= profil.pouzivatel_id.pouzivatel_pocet_ziakov ? vypracovanie.subory.length : profil.pouzivatel_id.pouzivatel_pocet_ziakov}} / {{ profil.pouzivatel_id.pouzivatel_pocet_ziakov }}
                </p>
                <router-link v-if="profil.pouzivatel_id" :to="{ name: 'skoly-ulohy', params: { 'rocnik': profil.pouzivatel_id.pouzivatel_rocnik } }" class="btn --primary">
                    spať na zoznam úloh<span class="icon --bars"></span>
                </router-link>
            </div>
        </article>

        <router-link v-if="profil.pouzivatel_id" :to="{ name: 'skoly-ulohy', params: { 'rocnik': profil.pouzivatel_id.pouzivatel_rocnik } }" class="btn --secondary --circle close-btn"><span class="icon --close"></span></router-link>
    </main>
</template>

<script>
import EventService from '@/services/EventService.js'
import HeaderProfil from '../partials/HeaderProfil.vue'
import MenuProfil   from '../partials/MenuProfil.vue'

import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

import BError from "@/components/b-error.vue";

export default {
    components: {
        BError,
        HeaderProfil,
        MenuProfil,
        vueDropzone: vue2Dropzone
    },
    props: [
        'profil',
        'spravy',
    ],
    data() {
        return {
            skolskaUloha: null,
            editovanie: false,
            vypracovanie: {
                uloha_id: null,
                pouzivatel_id: null,
                typ: 'tvoriva',
                subory: [],
                id: null,
            },
            dropzoneOptions: {
                url: `${ EventService.getSkolyApiUrl() }/api/vypracovania/upload?provider=players`,
                maxFilesize: 2,
                headers:{ "Authorization":'Bearer ' + localStorage.getItem("skoly-token") },
                addRemoveLinks: true,
                maxFiles: null,
                dictRemoveFile: 'Odstrániť',
                dictMaxFilesExceeded: 'Nie je možné nahrať viac súborov',
            },
            error: {},
            step: 'uvod',
            saving: false,
        }
    },
    mounted() {
        this.getSkolskaUloha()

        if ( typeof(this.profil.id) == "undefined" || this.profil.id === 0 ) {
            this.emitUpdateProfil()
        }
    },
    computed: {
        skolyStorage() {
            return EventService.getUlohyStorageUrl()
        },
        vypracovaniaStorage() {
            return EventService.getVypracovaniaStorageUrl()
        }
    },
    methods: {
        // emit
        emitUpdateProfil() {
            this.$emit('updateProfil')
        },

        async getSkolskaUloha() {
            let { data } = await EventService.getSkolskaUloha(this.$route.params.uloha_id)
            this.skolskaUloha = data.data

            if ( this.skolskaUloha.is_individualna ) {
                if ( this.profil.pouzivatel_id.pouzivatel_pocet_ziakov ) {
                    this.dropzoneOptions.maxFiles = this.profil.pouzivatel_id.pouzivatel_pocet_ziakov
                }
            } else {
                this.dropzoneOptions.maxFiles = 1
            }

            if ( this.skolskaUloha.vypracovania ) {
                let vypracovanie = this.skolskaUloha.vypracovania[0]
                if ( vypracovanie ) {
                    this.editovanie = true
                    this.vypracovanie.subory = vypracovanie.subory
                    this.vypracovanie.id = vypracovanie.id

                    for ( let subor of vypracovanie.subory ) {
                        this.$refs.submissionDropzone.manuallyAddFile(subor, this.vypracovaniaStorage + subor.name );
                    }
                }
            }

            let remainingSlots = this.dropzoneOptions.maxFiles - this.vypracovanie.subory.length
            this.$refs.submissionDropzone.setOption('maxFiles', remainingSlots)
        },

        async saveVypracovanie() {
            this.vypracovanie.uloha_id = this.$route.params.uloha_id
            this.vypracovanie.pouzivatel_id = this.profil.pouzivatel_id.id

            try {
                this.error = {}
                this.saving = true
                await EventService.saveVypracovanie( this.vypracovanie, this.editovanie )
                this.emitUpdateProfil()
                this.step = 'vyhodnotenie'
            } catch (e) {
                if ( e && e.response && e.response.data ) {
                    this.error = e.response.data
                } else {
                    this.$set(this.error, 'message', e.message)
                }
            } finally {
                this.saving = false
            }
        },

        fileUploaded(file, response) {
            try {
                this.vypracovanie.subory.push({ name: response.path + response.name, size: file.size, type: file.type })
            } catch (e) {
                this.$set(this.error, 'message', e.message)
            }
        },

        fileUploadError(file, message, xhr) {
            this.$set(this.error, 'message', message)
        },

        fileRemoved(file, error, xhr) {
            let deleteIndex = this.vypracovanie.subory.findIndex( subor => subor.name === file.name)
            if ( deleteIndex >= 0 ) {
                this.vypracovanie.subory.splice(deleteIndex, 1)
            }
        },

        addAdditionalParams(file, xhr, formData) {
            formData.append('uloha_id', this.skolskaUloha.id);
        }
    }
}
</script>
